module.exports = __webpack_public_path__ + "resources/img/solution_finance_cloud.fbcadd1aa3ab36e8d526a14539265be0.png";